var _rect, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#A1A9B2",
    fillOpacity: 0.2,
    stroke: "#A1A9B2",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 15.4315,
    y2: -0.75,
    transform: "matrix(0.701337 0.71283 -0.701337 0.71283 6 7)",
    stroke: "black",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 15.4315,
    y2: -0.75,
    transform: "matrix(0.701337 -0.71283 0.701337 0.71283 7.17969 18)",
    stroke: "black",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 15.4315,
    y2: -0.75,
    transform: "matrix(0.701337 0.71283 -0.701337 0.71283 6 7)",
    stroke: "#A1A9B2",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 15.4315,
    y2: -0.75,
    transform: "matrix(0.701337 -0.71283 0.701337 0.71283 7.17969 18)",
    stroke: "#A1A9B2",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.e9d50990.svg";
export { ForwardRef as ReactComponent };